import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
  import EntityItem from '@/_legacy/views/ConductInspection/Responses/EntityItem.vue';
  import Items from './Items';
  import { findResponseType } from '@/_legacy/store/checklist_builder';
  import { isEntityTypeOfResponseEnabled } from '@/ui/helpers/featureHelper';
  import { ResponsesTypes } from '@/entities/checklist';
  import InspectionEntityItemsHelper from '@/_legacy/helpers/inspectionEntityItemsHelper';
  import { useConductStore } from '@/stores/conduct/conduct';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Page',
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    inspection: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    errors: {
      type: Object,
      required: true,
    },
    showErrors: {
      type: Boolean,
      required: true,
    },
    responseSets: {
      type: Array,
      required: true,
    },
  },
  setup(__props) {

const props = __props;

  

  const { isTranslationEnabled } = useConductStore();

  const isHeaderPage = computed(() => props.item?.params?.header === true);

  const hasEntityItemWasMigrated = computed(() => {
    return InspectionEntityItemsHelper.wasEntityItemQuestionMigrated(props.inspection);
  });

  const hasNewEntityItemQuestion = computed(() => {
    return isEntityTypeOfResponseEnabled() && findResponseType(props.item, ResponsesTypes.entityItem);
  });

  const title = computed(() => {
    return isTranslationEnabled && props.item.title_translated
      ? props.item.title_translated
      : props.item.title;
  });

return { __sfc: true,props, isTranslationEnabled, isHeaderPage, hasEntityItemWasMigrated, hasNewEntityItemQuestion, title, EntityItem, Items }
}

})